import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
import { LocationBlock } from '../../components/LocationBlock';
export function SelfDefenseScheduleLocation() {
  return <section className="py-24 bg-off-white" data-id="element-3030">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3031">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-3032">
          <div data-id="element-3033">
            <h2 className="text-4xl text-ink mb-8" data-id="element-3034">Class Times</h2>
            <ScheduleTable data-id="element-3035" />
          </div>
          <div data-id="element-3036">
            <h2 className="text-4xl text-ink mb-8" data-id="element-3037">
              Taekwondo Classes in Farmington Hills, MI
            </h2>
            <LocationBlock data-id="element-3038" />
          </div>
        </div>
      </div>
    </section>;
}